'use client'
import { useHasCookie } from 'cookies-next/client'
import { ArrowRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { type FC } from 'react'
import useTryDemo from './hooks/use-try-demo'
import { Button, type ButtonProps } from './ui/button'

interface TryDemoProps {
  size?: ButtonProps['size']
}

const TryDemo: FC<TryDemoProps> = ({ size }) => {
  const t = useTranslations('Hero')
  const hasCookie = useHasCookie()
  const { loading, onSubmit } = useTryDemo({})

  return (
    <div className="sm:flex-shrink-0">
      <div>
        <Button onClick={() => onSubmit('landing')} className="w-full" size={size} variant={'default'} disabled={loading} aria-busy={loading}>
          {loading ? (
            <>
              <svg aria-hidden className="h-5 min-w-20 animate-spin" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 8a8 8 0 " />
              </svg>
              <span className="sr-only">{t('loading')}</span>
            </>
          ) : (
            <>
              {!hasCookie('DEMO_KEY') ? t('cta') : t('cta_has_demo')}
              <ArrowRight aria-hidden className="ml-2 h-5 w-5" />
            </>
          )}
        </Button>
      </div>
    </div>
  )
}

export default TryDemo
